import axios from "axios";

const CART_ITEM_CLASSNAME = "js-cart-item";
const CART_ITEM_REMOVE_BUTTON_CLASSNAME = "js-remove-cart-item";
const CART_CONTAINER_CLASSNAME = "js-cart-container";
const CART_CLOSE_BUTTON_CLASSNAME = "js-close-cart-button";
const CART_CHECKOUT_BUTTON_CLASSNAME = "js-cart-checkout";
const CART_ERROR_MESSAGE_CLASSNAME = "js-cart-error";
const CART_SUBTOTAL_CLASSNAME = "js-cart-subtotal";
const CART_EMPTY_TEMPLATE_CLASSNAME = "js-cart-empty-template";
const ITEM_DETAIL_ADD_TO_CART_SECTION_CLASSNAME = "js-item-detail-add-to-cart-section";
const ITEM_DETAIL_PURCHASE_EXCEED_SECTION_CLASSNAME = "js-item-detail-purchase-exceed-section";
const ITEM_DETAIL_SOLD_OUT_SECTION_CLASSNAME = "js-item-detail-sold-out-section";
const ADD_CART_BUTTON = "js-add-cart-button";

class MiniCart {
  isLoading = false;
  cartItemRemoveApiPath = null;
  $cartItemElement = null;
  $cartItemRemoveButton = null;
  $cartContainerElement = null;
  $cartErrorMessage = null;
  $cartSubtotalElement = null;
  $cartEmptyLi = null;

  static attach() {
    const $cartItemElements = document.querySelectorAll(`.${CART_ITEM_CLASSNAME}`);
    [...$cartItemElements].forEach(($cartItemElement) => {
      /* eslint-disable-next-line no-unused-vars */
      const miniCart = new MiniCart($cartItemElement);
    });
  }

  constructor($cartItemElement) {
    this.$cartItemElement = $cartItemElement;
    this.$cartItemRemoveButton = this.$cartItemElement.querySelector(
      `.${CART_ITEM_REMOVE_BUTTON_CLASSNAME}`
    );
    const { cartItemRemoveApiPath } = this.$cartItemElement.dataset;
    this.cartItemRemoveApiPath = cartItemRemoveApiPath;
    this.$cartContainerElement = document.querySelector(`.${CART_CONTAINER_CLASSNAME}`);
    this.$cartCloseButton = document.querySelector(`.${CART_CLOSE_BUTTON_CLASSNAME}`);
    this.$cartCheckoutButton = document.querySelector(`.${CART_CHECKOUT_BUTTON_CLASSNAME}`);
    this.$cartErrorMessage = document.querySelector(`.${CART_ERROR_MESSAGE_CLASSNAME}`);
    this.$cartSubtotalElement = document.querySelector(`.${CART_SUBTOTAL_CLASSNAME}`);

    const $cartEmptyTemplate = document.querySelector(`.${CART_EMPTY_TEMPLATE_CLASSNAME}`);
    if ($cartEmptyTemplate) {
      this.$cartEmptyLi = $cartEmptyTemplate.content.cloneNode(true);
    }

    if (this.$cartItemRemoveButton) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.$cartItemRemoveButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (!this.isLoading) {
        this.triggerApi();
      }
    });
  }

  triggerApi() {
    this.isLoading = true;

    axios({
      method: "GET",
      url: this.cartItemRemoveApiPath,
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then((response) => {
        /*
         * NOTE: if success, response should be
         * {
         *   success: true,
         *   subTotal: "¥5,000",
         * }
         *
         * NOTE: if failed, response should be
         * {
         *   success: false,
         *   message: "Unable to remove",
         * }
         */
        const { success, subTotal, message, canPurchaseItem, itemId, maxValue } = response.data;
        if (success) {
          this.$cartItemElement.remove();
          this.$cartSubtotalElement.innerText = subTotal;
          this.checkIsCartEmpty();

          const $addCartButtonElement = document.querySelector(`.${ADD_CART_BUTTON}`);
          const $itemDetailPurchaseExceedSectionElement = document.querySelector(
            `.${ITEM_DETAIL_PURCHASE_EXCEED_SECTION_CLASSNAME}`
          );
          const $itemDetailSoldOutSectionElement = document.querySelector(
            `.${ITEM_DETAIL_SOLD_OUT_SECTION_CLASSNAME}`
          );
          const $itemDetailAddToCartSectionElement = document.querySelector(
            `.${ITEM_DETAIL_ADD_TO_CART_SECTION_CLASSNAME}`
          );

          if (
            $itemDetailPurchaseExceedSectionElement &&
            $itemDetailSoldOutSectionElement &&
            $addCartButtonElement &&
            $itemDetailAddToCartSectionElement
          ) {
            const { addCartItemId } = $addCartButtonElement.dataset;
            if (canPurchaseItem && addCartItemId === itemId) {
              const $addToCartItemAmount = document.querySelector(
                ".js-add-to-cart-spinner .js-item-amount"
              );
              const $addToCartSpinnerUp = document.querySelector(
                ".js-add-to-cart-spinner .js-spinner-up"
              );
              const $addToCartSpinnerDown = document.querySelector(
                ".js-add-to-cart-spinner .js-spinner-down"
              );
              $addToCartItemAmount.setAttribute("max", maxValue);
              $addToCartItemAmount.value = 1;

              if (maxValue === 1) {
                // If user able to purchase one quantity only add "is-disabled" class
                $addToCartSpinnerUp.classList.add("is-disabled");
                $addToCartSpinnerDown.classList.add("is-disabled");
              } else if (parseInt($addToCartItemAmount.value, 10) === 1) {
                $addToCartSpinnerDown.classList.add("is-disabled");
                $addToCartSpinnerUp.classList.remove("is-disabled");
              } else if (
                parseInt($addToCartItemAmount.value, 10) === parseInt($addToCartItemAmount.max, 10)
              ) {
                $addToCartSpinnerUp.classList.add("is-disabled");
                $addToCartSpinnerDown.classList.remove("is-disabled");
              } else {
                $addToCartSpinnerUp.classList.remove("is-disabled");
                $addToCartSpinnerDown.classList.remove("is-disabled");
              }

              $itemDetailAddToCartSectionElement.removeAttribute("hidden");
              $itemDetailPurchaseExceedSectionElement.setAttribute("hidden", "");
              $itemDetailSoldOutSectionElement.setAttribute("hidden", "");
            }
          }

          return;
        }
        this.displayError(message);
      })
      .catch((error) => {
        this.isLoading = false;
        this.displayError(error.message);
      });
  }

  displayError(message) {
    this.$cartErrorMessage.innerHTML = message;
    this.$cartErrorMessage.classList.add("error");
    this.$cartErrorMessage.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });
  }

  checkIsCartEmpty() {
    const $allLiElements = this.$cartContainerElement.querySelectorAll(`.${CART_ITEM_CLASSNAME}`);
    if (!$allLiElements.length) {
      if (this.$cartEmptyLi) {
        const $targetUl = this.$cartContainerElement.querySelector("ul");
        $targetUl.appendChild(this.$cartEmptyLi);

        const $closeCartButton = $targetUl.querySelector(".close-cart-button");
        $closeCartButton.addEventListener("click", () => {
          this.$cartCloseButton.click();
        });

        if (this.$cartCheckoutButton) {
          this.$cartCheckoutButton.style.visibility = "hidden";
        }
      }
      this.$cartContainerElement.classList.add("empty-cart");

      // カートが空の場合、カートの赤い点を削除する
      const $cartElements = document.querySelectorAll(".header-cart-icon");
      if ($cartElements) {
        $cartElements.forEach((element) => {
          element.classList.remove("cart-added");
        });
      }
    } else {
      const $cartSoldOutErrorMessage = this.$cartContainerElement.querySelectorAll(
        ".js-sold-out-error-message.error-input.error"
      );

      // Check if the sold-out item is still available in the cart.
      if ($cartSoldOutErrorMessage.length) {
        this.$cartCheckoutButton.classList.add("disabled");
      } else {
        this.$cartCheckoutButton.classList.remove("disabled");
      }
    }
  }
}

export { MiniCart };
